// columnType.js

const ColumnType = Object.freeze({
  ORDER_TYPE: "ORDER_TYPE",
  //SUPPLIER_ORDER_NO: "SUPPLIER_ORDER_NO",
  SUPPLIER_ORDER_REFERENCE: "SUPPLIER_ORDER_REFERENCE",
  //ORDER_ID: "ORDER_ID",
  ORDER_REFERENCE: "ORDER_REFERENCE",
  RECEIVER: "RECEIVER",
  ORDER_DATE: "ORDER_DATE",
  SUMMARY: "SUMMARY",
  DELIVERY_ADDRESS_2: "DELIVERY_ADDRESS_2",
  DELIVERY_DATE: "DELIVERY_DATE",
  ORDER_STATUS: "ORDER_STATUS",
  SOURCE: "SOURCE",
  ROW_COUNT: "ROW_COUNT",
});

export default ColumnType;
